import _ from "lodash";

var MustacheHelper = /*#__PURE__*/function () {
  function MustacheHelper() {}

  var _proto = MustacheHelper.prototype;

  _proto.getCompiledText = function getCompiledText(rawText, valueMappings) {
    if (valueMappings === void 0) {
      valueMappings = {};
    }

    var compiled = _.template(rawText, {
      interpolate: /{{([\s\S]+?)}}/g
    });

    var compiledText = compiled(valueMappings);
    return compiledText;
  };

  return MustacheHelper;
}();

export default new MustacheHelper();